import { adminHttpClient } from '../commons/adminHttpClient'
import { ProductIds } from '../commons/config'
import { store } from '../commons/localStorage'

export interface AdminTask {
  id: number
  name: string
  description: string
  icon: string
  priority: number
  status: TaskStatus
  allowReview: boolean
  path?: string
  callback?: () => void | null
}

interface TasksMapping {
  benefitDesign: number
  completeProfile: number
  enrollEmployees: number
  finalizeBenefit: number
  inviteEmployees: number
}

export const ProductTaskIds: Map<ProductIds, TasksMapping> = new Map<number, TasksMapping>([
  [
    ProductIds.GroupHraId,
    {
      benefitDesign: 1,
      completeProfile: 2,
      enrollEmployees: 3,
      finalizeBenefit: 4,
      inviteEmployees: 5,
    },
  ],
  [
    ProductIds.Perks,
    {
      benefitDesign: 21,
      completeProfile: 22,
      enrollEmployees: 23,
      finalizeBenefit: 24,
      inviteEmployees: 25,
    },
  ],
  [
    ProductIds.QsehraId,
    {
      benefitDesign: 27,
      completeProfile: 28,
      enrollEmployees: 29,
      finalizeBenefit: 30,
      inviteEmployees: 31,
    },
  ],
  [
    ProductIds.IchraId,
    {
      benefitDesign: 38,
      completeProfile: 39,
      enrollEmployees: 40,
      finalizeBenefit: 41,
      inviteEmployees: 42,
    },
  ],
])

export const IchraRenewalTaskIds = {
  RedesignBenefit: 43,
  AssignClasses: 44,
  AcceptDocuments: 45,
  InviteEmployees: 46,
}

export const PerksRenewalTaskIds = {
  DesignBenefit: 47,
  AssignClasses: 48,
  InviteEmployees: 49,
}

export const QsehraRenewalTaskIds = {
  UpdatePaymentInformation: 33,
  RedesignBenefit: 34,
  ReassignEmployees: 35,
  FinalizeBenefitRenewal: 36,
  NotifyEmployeesForRenewal: 37,
}

export const GchraRenewalTaskIds = {
  InviteEmployees: 5,
  ConfirmGroupHealthPlanDetails: 7,
  ConfirmPaymentDetails: 8,
  RedesignBenefit: 9,
  NotifyEmployees: 12,
  ConfirmEmployeeClasses: 10,
  FinalizeBenefitRenewal: 11,
}

export const PerksProductTaskIds = ProductTaskIds.get(ProductIds.Perks)
export const GroupHraProductTaskIds = ProductTaskIds.get(ProductIds.GroupHraId)
export const QsehraHraProductTaskIds = ProductTaskIds.get(ProductIds.QsehraId)
export const IchraHraProductTaskIds = ProductTaskIds.get(ProductIds.IchraId)

export enum TaskStatus {
  Active = 0,
  Disabled = 1,
  Done = 2,
}

export const FIRST_LOGIN = 'firstLogin'

export const setFirstLogin = (value: string) => {
  store.set(FIRST_LOGIN, value)
}

export const getFirstLogin = (): string | null => {
  return store.get(FIRST_LOGIN)
}

export const getGroupHraAdminTasks = (): Promise<AdminTask[]> => {
  return adminHttpClient.get('/AdminDashboard/GroupHra/AdminTasks')
}

export const getPerksHraAdminTasks = (): Promise<AdminTask[]> => {
  return adminHttpClient.get('/AdminDashboard/Perks/AdminTasks')
}
